import { GOLD, ACCENT_GOLD, PARCHMENT } from '../../lib/medievalTheme';
import AvatarImage from './AvatarImage';
import { getCanvasScale } from '../../utils/uiScale';

// The wax-seal coin face from the achievement herald banner, extracted
// so every notification surface (achievement toast, sonner toasts,
// friend-request toast) stamps the same seal: gold rim, recessed stone
// interior, chiseled inset shadows, soft gold glow. Children render
// centered inside the coin. An ornament mask, an avatar, a glyph.
//
// `size` takes any CSS length. Inside .app-canvas use cqw; in surfaces
// that portal to document.body (sonner) pass canvas-scaled px. The
// 1.5px rim and inset shadows stay in px deliberately. Hairlines
// render crisp at every scale.
export default function HeraldSeal({ size, glowColor = `${GOLD} 0.4)`, style, children }) {
  return (
    <div
      className="relative rounded-full overflow-hidden flex items-center justify-center shrink-0"
      style={{
        width: size,
        height: size,
        background: 'radial-gradient(circle at 40% 35%, rgba(60, 44, 18, 0.98) 0%, rgba(20, 14, 6, 0.98) 70%)',
        border: `1.5px solid ${ACCENT_GOLD}`,
        boxShadow: [
          `inset 0 0 0 2px ${GOLD} 0.35)`,
          'inset 0 2px 4px rgba(255, 220, 140, 0.18)',
          'inset 0 -3px 6px rgba(0, 0, 0, 0.55)',
          `0 0 16px ${glowColor}`,
        ].join(', '),
        ...style,
      }}
    >
      {children}
    </div>
  );
}

// Seal pre-filled with a player avatar (or a bell glyph when there is
// none) for social/system notifications pushed through sonner. Sized
// in canvas-scaled px because sonner portals to document.body; read
// once at render. Toasts are transient, they don't need to track
// live scale changes.
export function HeraldAvatarSeal({ avatar }) {
  const size = Math.round(34 * getCanvasScale());
  return (
    <HeraldSeal size={`${size}px`}>
      {avatar ? (
        <AvatarImage src={avatar} className="w-full h-full" />
      ) : (
        <svg
          width={Math.round(15 * getCanvasScale())}
          height={Math.round(15 * getCanvasScale())}
          viewBox="0 0 24 24"
          fill="none"
          stroke={`${PARCHMENT} 0.9)`}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
          <path d="M13.7 21a2 2 0 0 1-3.4 0" />
        </svg>
      )}
    </HeraldSeal>
  );
}
